import { AC_POLICY_NAME } from '../components/documents/ACPolicy';
import { COST_ESTIMATE_AFTER_ACCIDENT_NAME } from '../components/documents/CostEstimateAfterAccident';
import { COST_ESTIMATE_BEFORE_ACCIDENT_NAME } from '../components/documents/CostEstimateBeforeAccident';
import { DAMAGE_PHOTOS_NAME } from '../components/documents/DamagePhotos';
import { INSURERS_DECISION_NAME } from '../components/documents/InsurersDecision';
import { INSURERS_ESTIMATE_NAME } from '../components/documents/InsurersEstimate';
import { INVOICES_RECEIPTS_OR_OTHER_DOCUMENTS_NAME } from '../components/documents/InvoicesReceiptsOrOtherDocuments';
import { OFFENDERS_STATEMENT_NAME } from '../components/documents/OffendersStatement';
import { REGISTRATION_CARD_NAME } from '../components/documents/RegistrationCard';
import { SALES_CONTRACT_NAME } from '../components/documents/SalesContract';

export const fullOC = [
  {
    label: 'Kosztorys ubezpieczyciela',
    name: INSURERS_ESTIMATE_NAME,
    required: true,
  },
  {
    label: 'Arkusz wyceny przed szkodą',
    name: COST_ESTIMATE_BEFORE_ACCIDENT_NAME,
    required: true,
  },
  {
    label: 'Arkusz wraku / wycena aukcji',
    name: COST_ESTIMATE_AFTER_ACCIDENT_NAME,
    required: true,
  },
  {
    label: 'Decyzja ubezpieczyciela',
    name: INSURERS_DECISION_NAME,
  },
  {
    label: 'Dowód rejestracyjny',
    name: REGISTRATION_CARD_NAME,
  },
  {
    label: 'Zdjęcia uszkodzeń',
    name: DAMAGE_PHOTOS_NAME,
  },
  {
    label: 'Oświadczenie sprawcy / notatka policyjna',
    name: OFFENDERS_STATEMENT_NAME,
  },
];

export const fullOCWithSale = [
  ...fullOC.slice(0, 1),
  {
    label: 'Umowa sprzedaży pojazdu',
    name: SALES_CONTRACT_NAME,
    required: true,
  },
  ...fullOC.slice(1),
];

export const partOC = [
  {
    label: 'Kosztorys ubezpieczyciela',
    name: INSURERS_ESTIMATE_NAME,
    required: true,
  },
  {
    label: 'Decyzja ubezpieczyciela',
    name: INSURERS_DECISION_NAME,
  },
  {
    label: 'Dowód rejestracyjny',
    name: REGISTRATION_CARD_NAME,
  },
  {
    label: 'Zdjęcia uszkodzeń',
    name: DAMAGE_PHOTOS_NAME,
  },
  {
    label: 'Oświadczenie sprawcy / notatka policyjna',
    name: OFFENDERS_STATEMENT_NAME,
  },
  {
    label: 'Arkusz wyceny przed szkodą',
    name: COST_ESTIMATE_BEFORE_ACCIDENT_NAME,
  },
];

export const partOCWithSale = [
  ...partOC.slice(0, 1),
  {
    label: 'Umowa sprzedaży pojazdu',
    name: SALES_CONTRACT_NAME,
    required: true,
  },
  ...partOC.slice(1),
];

export const partAC = [
  {
    label: 'Kosztorys ubezpieczyciela',
    name: INSURERS_ESTIMATE_NAME,
    required: true,
  },
  {
    label: 'Polisa AC',
    name: AC_POLICY_NAME,
    required: true,
  },
  {
    label: 'Decyzja ubezpieczyciela',
    name: INSURERS_DECISION_NAME,
  },
  {
    label: 'Dowód rejestracyjny',
    name: REGISTRATION_CARD_NAME,
  },
  {
    label: 'Zdjęcia uszkodzeń',
    name: DAMAGE_PHOTOS_NAME,
  },
];

export const partACWithSale = [
  ...partAC.slice(0, 1),
  {
    label: 'Umowa sprzedaży pojazdu',
    name: SALES_CONTRACT_NAME,
    required: true,
  },
  ...partAC.slice(1),
];

export const fullAC = [
  {
    label: 'Kosztorys ubezpieczyciela',
    name: INSURERS_ESTIMATE_NAME,
    required: true,
  },
  {
    label: 'Polisa AC',
    name: AC_POLICY_NAME,
    required: true,
  },
  {
    label: 'Decyzja ubezpieczyciela',
    name: INSURERS_DECISION_NAME,
    required: true,
  },
  {
    label: 'Arkusz wyceny przed szkodą',
    name: COST_ESTIMATE_BEFORE_ACCIDENT_NAME,
    required: true,
  },
  {
    label: 'Arkusz wraku / wycena aukcji',
    name: COST_ESTIMATE_AFTER_ACCIDENT_NAME,
    required: true,
  },
  {
    label: 'Dowód rejestracyjny',
    name: REGISTRATION_CARD_NAME,
  },
  {
    label: 'Zdjęcia uszkodzeń',
    name: DAMAGE_PHOTOS_NAME,
  },
];

export const fullACWithSale = [
  ...fullAC.slice(0, 1),
  {
    label: 'Umowa sprzedaży pojazdu',
    name: SALES_CONTRACT_NAME,
    required: true,
  },
  ...fullAC.slice(1),
];

// Utility: mark DAMAGE_PHOTOS_NAME as required when requested
export type DocumentStep = {
  label?: string;
  name?: string;
  required?: boolean;
  // Allow additional fields without constraining callers
  [key: string]: unknown;
};

export function applyDocumentStepRequirements(
  withDamagePhotosRequired: boolean,
  withInvoicesReceiptsOrOtherDocumentsRequired: boolean,
  steps: DocumentStep[] | null | undefined
): DocumentStep[] {
  if (!Array.isArray(steps) || steps.length === 0) return [];

  if (
    !withDamagePhotosRequired &&
    !withInvoicesReceiptsOrOtherDocumentsRequired
  ) {
    return [...steps];
  }

  const mappedSteps = steps.map((step) => {
    if (!step) return step;

    if (withDamagePhotosRequired && step.name === DAMAGE_PHOTOS_NAME) {
      return { ...step, required: true };
    }

    return { ...step };
  });

  if (withInvoicesReceiptsOrOtherDocumentsRequired) {
    mappedSteps.push({
      label: 'Faktury, rachunki lub inne dokumenty',
      name: INVOICES_RECEIPTS_OR_OTHER_DOCUMENTS_NAME,
      required: true,
      id: 'withInvoicesReceiptsOrOtherDocumentsRequired',
    });
  }

  return mappedSteps;
}
